import { useEffect, useState } from 'react'

function usePageConfig({ listener = 'window-config-loaded', checkIfAvailable = true } = {}) {
  const [pageConfig, setPageConfig] = useState(() =>
    typeof window !== 'undefined' && checkIfAvailable ? window.pageConfig : undefined
  )

  useEffect(() => {
    function setAndCheckPageConfig() {
      setPageConfig(window.pageConfig)
    }

    // /load-services.js dispatches its config events exactly once, then sets
    // `servicesLoaded`. A component whose effects run after that (heavy hydration
    // losing the race to the `load`-triggered fetch) would never receive the event
    // and stay on the SSR default forever, so adopt the already-landed config.
    const fullConfigLanded = window.pageConfig?.servicesLoaded === true
    if (window.pageConfig && !pageConfig && (checkIfAvailable || fullConfigLanded)) {
      setAndCheckPageConfig()
    }

    window.addEventListener(listener, setAndCheckPageConfig)

    return () => {
      window.removeEventListener(listener, setAndCheckPageConfig)
    }
  }, [])

  return pageConfig
}

export default usePageConfig
